import { getUser } from '../../AppServices';
import { publicRoutes } from '../../routes';

const decodeAction = ({ path, action }) => {
  if (!action) {
    return path;
  }
  if (typeof action === 'string') {
    path += `:${action}`;
    return path;
  }
  if (action.view) {
    path += `:${action.view}`;
    return decodeAction({ path, action: action.action });
  }
};

export const getPathName = () => {
  const { pathname } =
    typeof window !== undefined ? window.location : { pathname: '/' };
  return { pathName: pathname };
};

export const setPathName = ({ pathName, replace, remove }) => {
  const { pathname: currentPathName } =
    typeof window !== undefined ? window.location : { pathname: '/' };

  const { history } = window;
  if (history && currentPathName !== pathName) {
    if (remove) {
      let removeCount = 1;
      if (typeof remove === 'number') {
        removeCount = 1;
      }
      history.go(removeCount);
    } else if (replace) {
      history.replaceState({}, '', pathName);
    } else {
      history.pushState({}, '', pathName);
    }
  }
};

export const setLocationView = ({ view, action }) => {
  let path = '/';
  if (view && typeof view === 'string') {
    path += view;
  }
  path = decodeAction({ path, action });

  const { pathname: currentPathname } = window.location;

  const { history } = window;
  if (history && currentPathname !== path) {
    history.pushState({}, '', path);
  }
};


export const getLocationView = ({ pathName }) => {
  console.log("pathName getLocationView", pathName)
  const slashIndex = pathName.indexOf('/');
  console.log("slashIndex", slashIndex)
  if (slashIndex >= 0) {
    pathName = pathName.substring(slashIndex + 1);
  }
  if (!pathName) {
    return void 0;
  }
  const actions = pathName.split(':');
  if (actions && actions.length) {
    const view = {
      view: actions[0],
    };

    if (actions.length > 1) {
      let lastViewAction = view;
      for (let index = 1; index < actions.length; index++) {
        lastViewAction.action = {
          view: actions[index],
        };
        lastViewAction = lastViewAction.action;
      }
    }
    return view;
  }
};

export const getDefaultLocationView = (view) => {
  console.log("view", view)
  let { pathname, hash } = typeof window !== undefined ? window.location : { pathname: '/' };
  console.log('pathname', pathname) 

  if (pathname === '/landing') {
    return {
      view: "login"
    };
  }

  if (pathname === '/login') {

    return {
      view: "login"
    };
  }

  // if (pathname === '/contactUs') {

  //   return {
  //     view: "contactUs"
  //   };
  // }


  const pathSegments = pathname.split('/');
  const pathSegmentsUnsubscribe = pathSegments[1]
  const token = pathSegments[pathSegments.length - 1];
  
  console.log('pathSegmentsUnsubscribe', pathSegmentsUnsubscribe); // This will log the extracted token value

  if (pathSegmentsUnsubscribe === 'unsubscribe') {
    console.log('insideee')
    return {
      view: `unsubscribe/${token}`
    };
  }

  if (pathSegmentsUnsubscribe === 'customer-interest') {
    return {
      view: `customer-interest/${token}`
    };
  }


  if (publicRoutes.includes(pathname)) {
    return { ...view, params: hash };
  }
  
  if (
    pathname === '/otp' ||
    pathname === '/authenticator'
  ) {
    console.log("step2 insideee")

    pathname = '/';
  }

  if (!getUser()) {
    return view;
  }

  if (pathname === '/landing') {
    return view;
  }

  return getLocationView({ pathName: pathname }) || view;
};
